export const colorModes = {
	bright: 'bright',
	dark: 'dark',
};

export const fontSizes = {
	smaller: 'smaller',
	medium: 'medium',
	larger: 'larger',
	largest: 'largest',
};

export const viewSize = {
	large: 'large',
	medium: 'medium',
	small: 'small',
	xlarge: 'xlarge',
	xsmall: 'xsmall',
	xxsmall: 'xxsmall',
};

export const elementTranslation = {
	blocked: 'blocked',
	found: 'found',
	missing: 'missing',
};

export const meaning = {
	despised: 'despised',
	error: 'error',
	info: 'info',
	unkown: 'unkown',
	warning: 'warning',
};

export const BEHAVIOUR = {
	mediaPlayer: 'mediaplayer',
	mobile: 'mobile',
};

export const PLAYER_STATE = {
	emtpy: 'empty',
	loading: 'loading',
	paused: 'paused',
	playing: 'playing',
	stopped: 'stopped',
	syncing: 'syncing',
	ended: 'ended',
};

export const PLAYER_TYPE = {
	default: 'default',
	synced: 'synced',
};

export const BATTERY_STATE = {
	CHARGING: 'charging',
	DISCHARGING: 'discharging',
	FULL: 'full',
	UNKOWN: 'unkown',
};

export const STATUS_LED = {
	error: 'error',
	ok: 'ok',
	unkown: 'unkown',
};

export const BEACON_TYPE = {
	area: 'area',
	blocker: 'blocker',
	delayedTrigger: 'delayedTrigger',
	extender: 'extender',
	gate: 'gate',
	trigger: 'trigger',
};

export const BLUETOOTH_ENABLE_RESULT = {
	agreed: 'agreed', // (user agreed to enable Bluetooth, but the actual outcome is unsure)
	alreadyOn: 'already-on', // (Bluetooth was already on)
	denied: 'denied', // (user did not want Bluetooth)
	enabled: 'enabled', // (user enabled Bluetooth)
	hardwareError: 'hardware-error', // (user tried to enable Bluetooth, but there was hardware error)
	notAvailable: 'not-available', // (BLE is not available)
};

export const SEARCH_SCOPES = {
	tour: 'tour',
	locations: 'locations',
	glossary: 'glossary',
	exhibitions: 'exhibitions',
	calendar: 'calendar',
	areabeacons: 'areabeacons',
	articles: 'articles',
	tours: 'tours',
};

export const PACKAGE_SYNCER_MODES = {
	all: 'all',
	tour: 'tour',
	exhibition: 'exhibition',
	// initial download of all files for the progressive web app
	initial: 'initial',
};

export const syncActionStates = {
	loadPending: 'loadPending',
	loading: 'loading',
	loaded: 'downloaded',
	loadIncomplete: 'loadIncomplete',
	deletePending: 'deletePending',
	deleting: 'deleting',
};
